// extracted by mini-css-extract-plugin
export var alignCenter = "_7h-d";
export var bannerShown = "_7h-6";
export var buttonContent = "_7h-0";
export var cardList = "_7h-1";
export var centerContent = "_7h-2";
export var chevron = "_7h-3";
export var closePanelButton = "_7h-k";
export var conversationContextContainer = "_7h-l";
export var conversationDetailContainer = "_7h-4";
export var detailWrapper = "_7h-7";
export var dropdownButton = "_7h-e";
export var dropdownTitle = "_7h-9";
export var fullHeight = "_7h-5";
export var hidden = "_7h-a";
export var icon = "_7h-b";
export var mergeSuggestionWrapper = "_7h-m";
export var panel = "_7h-i";
export var portalButtonsWrapper = "_7h-c";
export var right = "_7h-j";
export var tableSummaryContainer = "_7h-8";
export var tableSummaryHeader = "_7h-g";
export var threeDotsButton = "_7h-f";
export var wide = "_7h-h";